import axios from "axios";
import { readAttribution } from "./attribution";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function fetchContent(path) {
  const { data } = await api.get(`/content`, { params: { path } });
  return data;
}

export async function fetchBusiness() {
  const { data } = await api.get(`/business`);
  return data;
}

export async function submitContact(payload) {
  // Attach how this visitor arrived so Clio Grow, and any ad report
  // built on top of it, can tell paid from organic.
  const body = { attribution: readAttribution(), ...payload };
  const { data } = await api.post(`/contact`, body);
  return data;
}

export async function fetchTestimonials(lang) {
  const { data } = await api.get(`/testimonials`, { params: lang ? { lang } : {} });
  return data;
}

/** [Phase 26] Live Google reviews snapshot (rating, count, highlights). */
export async function fetchReviews(lang) {
  const { data } = await api.get(`/reviews`, { params: lang ? { lang } : {} });
  return data;
}
